import React from 'react';
import Header from '../../components/Header';
import FormReviewDetails from '../../components/ProfileInfoComponents/FormReviewDetails';
import { useHistory } from 'react-router-dom';
import './styles.scss';
import { Box, IconButton, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import PageTitle from '@components/PageTitle';

const ProfileInfoPage = () => {
  const history = useHistory();

  return (
    <React.Fragment>
      <Box sx={{ p: 1 }}>
        <PageTitle title="Profile Information" />
        <FormReviewDetails/>
      </Box>
    </React.Fragment>
  );
};

export default ProfileInfoPage;